import React, { useState } from "react";
import { CCollapse } from "@coreui/react";

const QuestionItemInfo = ({ questionName, notes }) => {
  const [isOpen, setIsOpen] = useState(false);

  const noteValue = notes[questionName];
  if (!noteValue) return null;

  // Support plain string notes (current format) or future {text, videoUrl} objects
  const text = typeof noteValue === "object" ? noteValue.text : noteValue;
  const videoUrl = typeof noteValue === "object" ? noteValue.videoUrl : null;

  return (
    <div className="question-item-info">
      <button
        type="button"
        className={`question-item-info__trigger${isOpen ? " is-open" : ""}`}
        onClick={() => setIsOpen(prev => !prev)}
        aria-expanded={isOpen}>
        <span className="question-item-info__label">
          <svg
            className="question-item-info__icon"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            aria-hidden="true">
            <circle
              cx="8"
              cy="8"
              r="7"
              stroke="currentColor"
              strokeWidth="1.5"
            />
            <path
              d="M8 7.25V11.5"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <circle cx="8" cy="4.85" r="0.9" fill="currentColor" />
          </svg>
          <span className="question-item-info__title">Information</span>
        </span>
        <svg
          className="question-item-info__chevron"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          aria-hidden="true">
          <path
            d="M4 6L8 10L12 6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <CCollapse visible={isOpen}>
        <div className="question-item-info__body">
          <pre className="question-item-info__text">{text}</pre>
          {videoUrl && (
            <div className="question-item-info__video-row">
              <a
                href={videoUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="question-item-info__video-link">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  aria-hidden="true">
                  <circle
                    cx="9"
                    cy="9"
                    r="8"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M7 6.5L12 9L7 11.5V6.5Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                  />
                </svg>
                Watch video
              </a>
            </div>
          )}
        </div>
      </CCollapse>
    </div>
  );
};

export default QuestionItemInfo;
